import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import getCreateApp from './createApp';
import getCreatePage from './createPage';
import { getMergedArrayOption } from './utils';
export default function createRegistry() {
  var registered = [];

  var instance = function createPage(Component, options) {
    return instance.createPage(Component, options);
  };

  if (!process.browser) {
    var getCreateDocument = require('./createDocument')["default"];

    instance.createDocument = getCreateDocument(instance);
  } // Give access to the function that created this registry. Then if you get
  // access to this registry you can easily create a fresh one without importing
  // and depending on `@techstyle/next-server` directly.


  instance.createRegistry = createRegistry;
  instance.createApp = getCreateApp(instance);
  instance.createPage = getCreatePage(instance);
  instance.utils = {
    getMergedArrayOption: getMergedArrayOption
  };

  instance.register = function (extension) {
    // Allow extension to be a function that accepts the registry as the first
    // argument. This allows the extension to see or add others.
    if (typeof extension === 'function') {// Lazily initialize when extensions start being accessed.
    } else if (!extension) {
      throw new Error("Did not receive an extension to register; received ".concat(extension, " instead."));
    } else if (typeof extension.id !== 'string') {
      throw new Error("Extensions must have a ID string, but the 'id' property was ".concat(extension.id));
    }

    registered.push(extension);
  };

  instance.getRegistered = function () {
    return registered;
  };

  instance.forEach = function (callback, thisArg) {
    for (var i = 0; i < registered.length; i++) {
      var extension = registered[i];

      if (typeof extension === 'function') {
        extension = extension(instance);
        registered[i] = extension;
      }

      callback.call(thisArg, extension, i, registered);
    }
  };

  instance.forEachAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(callback, thisArg) {
      var i, extension;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              i = 0;

            case 1:
              if (!(i < registered.length)) {
                _context.next = 9;
                break;
              }

              extension = registered[i];

              if (typeof extension === 'function') {
                extension = extension(instance);
                registered[i] = extension;
              }

              _context.next = 6;
              return callback.call(thisArg, extension, i, registered);

            case 6:
              i++;
              _context.next = 1;
              break;

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  instance.forEachReverse = function (callback, thisArg) {
    for (var i = registered.length - 1; i >= 0; i--) {
      var extension = registered[i];

      if (typeof extension === 'function') {
        extension = extension(instance);
        registered[i] = extension;
      }

      callback.call(thisArg, extension, i, registered);
    }
  };

  if (!process.browser) {
    instance.server = {
      init: function init(server) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return instance.forEachAsync( /*#__PURE__*/function () {
                    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(extension) {
                      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              if (!(extension.server && extension.server.init)) {
                                _context2.next = 3;
                                break;
                              }

                              _context2.next = 3;
                              return extension.server.init(server);

                            case 3:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2);
                    }));

                    return function (_x3) {
                      return _ref2.apply(this, arguments);
                    };
                  }());

                case 2:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))();
      },
      handler: function handler(_ref3) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
          var handler, app, server;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  handler = _ref3.handler, app = _ref3.app, server = _ref3.server;
                  instance.forEachReverse(function (extension) {
                    if (extension.server && extension.server.handler) {
                      var newHandler = extension.server.handler({
                        handler: handler,
                        app: app,
                        server: server
                      });

                      if (newHandler != null) {
                        handler = newHandler;
                      }
                    }
                  });
                  return _context4.abrupt("return", handler);

                case 3:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }))();
      },
      configure: function configure(server) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.next = 2;
                  return instance.forEachAsync( /*#__PURE__*/function () {
                    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(extension) {
                      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              if (!(extension.server && extension.server.configure)) {
                                _context5.next = 3;
                                break;
                              }

                              _context5.next = 3;
                              return extension.server.configure(server);

                            case 3:
                            case "end":
                              return _context5.stop();
                          }
                        }
                      }, _callee5);
                    }));

                    return function (_x4) {
                      return _ref4.apply(this, arguments);
                    };
                  }());

                case 2:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }))();
      },
      configureInitialMiddleware: function configureInitialMiddleware(server) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.next = 2;
                  return instance.forEachAsync( /*#__PURE__*/function () {
                    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(extension) {
                      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                        while (1) {
                          switch (_context7.prev = _context7.next) {
                            case 0:
                              if (!(extension.server && extension.server.configureInitialMiddleware)) {
                                _context7.next = 3;
                                break;
                              }

                              _context7.next = 3;
                              return extension.server.configureInitialMiddleware(server);

                            case 3:
                            case "end":
                              return _context7.stop();
                          }
                        }
                      }, _callee7);
                    }));

                    return function (_x5) {
                      return _ref5.apply(this, arguments);
                    };
                  }());

                case 2:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }))();
      },
      configureErrorMiddleware: function configureErrorMiddleware(server) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
          return _regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  _context10.next = 2;
                  return instance.forEachAsync( /*#__PURE__*/function () {
                    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(extension) {
                      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                        while (1) {
                          switch (_context9.prev = _context9.next) {
                            case 0:
                              if (!(extension.server && extension.server.configureErrorMiddleware)) {
                                _context9.next = 3;
                                break;
                              }

                              _context9.next = 3;
                              return extension.server.configureErrorMiddleware(server);

                            case 3:
                            case "end":
                              return _context9.stop();
                          }
                        }
                      }, _callee9);
                    }));

                    return function (_x6) {
                      return _ref6.apply(this, arguments);
                    };
                  }());

                case 2:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10);
        }))();
      }
    };
    instance.document = {
      enhance: function enhance(Document) {
        instance.forEachReverse(function (extension) {
          if (extension.document && extension.document.enhance) {
            Document = extension.document.enhance(Document);
          }
        });
        return Document;
      },
      enhanceInitialProps: function enhanceInitialProps(getInitialProps) {
        instance.forEachReverse(function (extension) {
          if (extension.document && extension.document.getInitialProps && typeof extension.document.getInitialProps.enhance === 'function') {
            getInitialProps = extension.document.getInitialProps.enhance(getInitialProps);
          }
        });
        return getInitialProps;
      },
      getInitialProps: function getInitialProps(ctx) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
          var promises, initialProps;
          return _regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  promises = [];
                  instance.forEach(function (extension) {
                    if (extension.document && typeof extension.document.getInitialProps === 'function') {
                      var promise = extension.document.getInitialProps(ctx);
                      promises.push(promise);
                    }
                  });
                  _context11.next = 4;
                  return Promise.all(promises);

                case 4:
                  initialProps = _context11.sent;
                  return _context11.abrupt("return", Object.assign.apply(Object, [{}].concat(_toConsumableArray(initialProps))));

                case 6:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee11);
        }))();
      }
    };
  }

  instance.app = {
    enhance: function enhance(App) {
      instance.forEachReverse(function (extension) {
        if (extension.app && extension.app.enhance) {
          App = extension.app.enhance(App);
        }
      });
      return App;
    },
    enhanceInitialProps: function enhanceInitialProps(getInitialProps) {
      instance.forEachReverse(function (extension) {
        if (extension.app && extension.app.getInitialProps && typeof extension.app.getInitialProps.enhance === 'function') {
          getInitialProps = extension.app.getInitialProps.enhance(getInitialProps);
        }
      });
      return getInitialProps;
    },
    getInitialProps: function getInitialProps(_ref7) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var Component, ctx, promises, initialProps;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                Component = _ref7.Component, ctx = _ref7.ctx;
                promises = [];
                instance.forEach(function (extension) {
                  if (extension.app && typeof extension.app.getInitialProps === 'function') {
                    var promise = extension.app.getInitialProps({
                      Component: Component,
                      ctx: ctx
                    });
                    promises.push(promise);
                  }
                });
                _context12.next = 5;
                return Promise.all(promises);

              case 5:
                initialProps = _context12.sent;
                return _context12.abrupt("return", Object.assign.apply(Object, [{}].concat(_toConsumableArray(initialProps))));

              case 7:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }))();
    },
    render: function render(props, children) {
      instance.forEachReverse(function (extension) {
        if (extension.app && extension.app.render) {
          children = extension.app.render(props, children);
        }
      });
      return children;
    }
  };

  instance.page = function (options) {
    return {
      enhance: function enhance(Page) {
        instance.forEachReverse(function (extension) {
          var page = typeof extension.page === 'function' ? extension.page(options) : extension.page;

          if (page && page.enhance) {
            Page = page.enhance(Page);
          }
        });
        return Page;
      },
      enhanceInitialProps: function enhanceInitialProps(getInitialProps) {
        instance.forEachReverse(function (extension) {
          var page = typeof extension.page === 'function' ? extension.page(options) : extension.page;

          if (page && page.getInitialProps && typeof page.getInitialProps.enhance === 'function') {
            getInitialProps = page.getInitialProps.enhance(getInitialProps);
          }
        });
        return getInitialProps;
      },
      getInitialProps: function getInitialProps(ctx) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
          var promises, initialProps;
          return _regeneratorRuntime.wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  promises = [];
                  instance.forEach(function (extension) {
                    var page = typeof extension.page === 'function' ? extension.page(options) : extension.page;

                    if (page && typeof page.getInitialProps === 'function') {
                      var promise = page.getInitialProps(ctx);
                      promises.push(promise);
                    }
                  });
                  _context13.next = 4;
                  return Promise.all(promises);

                case 4:
                  initialProps = _context13.sent;
                  return _context13.abrupt("return", Object.assign.apply(Object, [{}].concat(_toConsumableArray(initialProps))));

                case 6:
                case "end":
                  return _context13.stop();
              }
            }
          }, _callee13);
        }))();
      },
      render: function render(props, children) {
        instance.forEachReverse(function (extension) {
          var page = typeof extension.page === 'function' ? extension.page(options) : extension.page;

          if (page && page.render) {
            children = page.render(props, children);
          }
        });
        return children;
      }
    };
  };

  return instance;
}